import { useRef, useEffect } from "react";

/** Returns a ref for a setTimeout handle that is auto-cleared on unmount. */
export function useTimeoutRef() {
  const ref = useRef<ReturnType<typeof setTimeout> | null>(null);
  useEffect(() => () => { if (ref.current) clearTimeout(ref.current); }, []);
  return ref;
}
